import {LABEL_COMING_SOON} from '/enum/label.enum';

export const RESPONSE_SCHEMA_DASHBOARD_CLIENTS = {
  clients: {
    newFrontlineClientsCount: LABEL_COMING_SOON,
    frontlineClientsCount: LABEL_COMING_SOON,
    lastMonthFrontlineClientsCount: LABEL_COMING_SOON,
    newOrgClientsCount: LABEL_COMING_SOON,
    orgClientsCount: LABEL_COMING_SOON,
    lastMonthOrgClientsCount: LABEL_COMING_SOON,
    newGen0ClientsCount: LABEL_COMING_SOON,
    gen0ClientsCount: LABEL_COMING_SOON,
    lastMonthGen0ClientsCount: LABEL_COMING_SOON,
    inactiveClientsCount: LABEL_COMING_SOON,
    premierCancellationsCount: LABEL_COMING_SOON,
    newClientsWithoutOrdersCount: LABEL_COMING_SOON,
    frontlineClientsWithExpiringWellnessCreditsCount: LABEL_COMING_SOON,
    frontlineClientsWithExpiringRewardsCount: LABEL_COMING_SOON,
  },
  orders: {
    totalGenerationVolume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
      calculatedValue: LABEL_COMING_SOON,
    },
    gen0Volume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
      calculatedValue: LABEL_COMING_SOON,
    },
    frontlineVolume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
      calculatedValue: LABEL_COMING_SOON,
    },
    frontlineOrdersFromNewClientsCount: LABEL_COMING_SOON,
    frontlineOrdersCount: LABEL_COMING_SOON,
    gen0OrdersFromNewClientsCount: LABEL_COMING_SOON,
    gen0OrdersCount: LABEL_COMING_SOON,
    orgOrdersFromNewClientsCount: LABEL_COMING_SOON,
    orgOrdersCount: LABEL_COMING_SOON,
  },
};

export const RESPONSE_SCHEMA_DASHBOARD_HOME = {
  frontlineQualifyingVolume: {
    current: LABEL_COMING_SOON,
    projectedThisMonth: LABEL_COMING_SOON,
    totalLastMonth: LABEL_COMING_SOON,
  },
  gen0Volume: {
    current: LABEL_COMING_SOON,
    projectedThisMonth: LABEL_COMING_SOON,
    totalLastMonth: LABEL_COMING_SOON,
  },
  totalGenerationVolume: {
    current: LABEL_COMING_SOON,
    projectedThisMonth: LABEL_COMING_SOON,
    totalLastMonth: LABEL_COMING_SOON,
  },
  clients: {
    newFrontlineClientsCount: LABEL_COMING_SOON,
    frontlineClientsCount: LABEL_COMING_SOON,
    newGen0ClientsCount: LABEL_COMING_SOON,
    gen0ClientsCount: LABEL_COMING_SOON,
    inactiveClientsCount: LABEL_COMING_SOON,
    organizationClientsCount: LABEL_COMING_SOON,
    newOrganizationClientsCount: LABEL_COMING_SOON,
  },
  coaches: {
    newFrontlineCoachesCount: LABEL_COMING_SOON,
    frontlineCoachesCount: LABEL_COMING_SOON,
    newOrganizationCoachesCount: LABEL_COMING_SOON,
    organizationCoachesCount: LABEL_COMING_SOON,
    newGen0CoachesCount: LABEL_COMING_SOON,
    gen0CoachesCount: LABEL_COMING_SOON,
    myTeamsCount: LABEL_COMING_SOON,
  },
  teams: {
    seniorCoachTeamsCount: LABEL_COMING_SOON,
    executiveDirectorTeamsCount: LABEL_COMING_SOON,
    fibcTeamsCount: LABEL_COMING_SOON,
    fiblTeamsCount: LABEL_COMING_SOON,
  },
  allOrgClientsWithExpiringWellnessCreditsCount: LABEL_COMING_SOON,
  frontlineClientsWithExpiringWellnessCreditsCount: LABEL_COMING_SOON,
  frontlineClientsWithExpiringRewardsCount: LABEL_COMING_SOON,
};

export const RESPONSE_SCHEMA_DASHBOARD_TEAMS = {
  coaches: {
    rankUpCount: LABEL_COMING_SOON,
    earnedClientAcquisitionBonusCount: LABEL_COMING_SOON,
    earnedQuickStartBonusCount: LABEL_COMING_SOON,
    newGen0CoachesCount: LABEL_COMING_SOON,
    gen0CoachesCount: LABEL_COMING_SOON,
    newFrontlineCoachesCount: LABEL_COMING_SOON,
    frontlineCoachesCount: LABEL_COMING_SOON,
    newOrganizationCoachesCount: LABEL_COMING_SOON,
    organizationCoachesCount: LABEL_COMING_SOON,
    earnedAccelBonusCount: LABEL_COMING_SOON,
    myTeamsCount: LABEL_COMING_SOON,
  },
  teams: {
    seniorCoachTeamsCount: LABEL_COMING_SOON,
    executiveDirectorTeamsCount: LABEL_COMING_SOON,
    fibcTeamsCount: LABEL_COMING_SOON,
    fiblTeamsCount: LABEL_COMING_SOON,
    frontlineQualifyingVolume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
    },
    gen0Volume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
    },
    totalGenerationVolume: {
      current: LABEL_COMING_SOON,
      projected: LABEL_COMING_SOON,
    },
  },
  rankPerformance: {
    aboveRankCount: LABEL_COMING_SOON,
    atRankCount: LABEL_COMING_SOON,
    belowRankCount: LABEL_COMING_SOON,
  },
  closeToRank: {
    seniorCoachCount: LABEL_COMING_SOON,
    executiveDirectorCount: LABEL_COMING_SOON,
    fibcCount: LABEL_COMING_SOON,
  },
  bonuses: {
    eligibleForCabCount: LABEL_COMING_SOON,
    eligibleForQsbCount: LABEL_COMING_SOON,
    eligibleForAccelBonusCount: LABEL_COMING_SOON,
  },
  atRisk: {
    activeNotCertifiedCount: LABEL_COMING_SOON,
    expiringCoachRenewalsCount: LABEL_COMING_SOON,
  },
};

export const RESPONSE_SCHEMA_COACH_PERFORMANCE = {
  frontline: {
    volumeThisMonth: LABEL_COMING_SOON,
    projectedPremierVolumeThisMonth: LABEL_COMING_SOON,
    volumeThisTimeLastMonth: LABEL_COMING_SOON,
  },
  gen0: {
    volumeThisMonth: LABEL_COMING_SOON,
    projectedPremierVolumeThisMonth: LABEL_COMING_SOON,
    volumeThisTimeLastMonth: LABEL_COMING_SOON,
  },
  totalGeneration: {
    volumeThisMonth: LABEL_COMING_SOON,
    volumeThisTimeLastMonth: LABEL_COMING_SOON,
  },
  orderingEntitiesCount: LABEL_COMING_SOON,
  qualifyingPoints: LABEL_COMING_SOON,
  newFrontlineClientsThisMonthCount: LABEL_COMING_SOON,
  newFrontlineCoachesThisMonthCount: LABEL_COMING_SOON,
  newGen0ClientsThisMonthCount: LABEL_COMING_SOON,
  newGen0CoachesThisMonthCount: LABEL_COMING_SOON,
  currentPremierVolume: LABEL_COMING_SOON,
  projectedPremierVolume: LABEL_COMING_SOON,
  newOrgClientsThisMonthCount: LABEL_COMING_SOON,
  newOrgCoachsThisMonthCount: LABEL_COMING_SOON,
  totalProjectedVolume: LABEL_COMING_SOON,
  earnings: {
    commissionLastWeek: {
      amount: LABEL_COMING_SOON,
      currencyCode: LABEL_COMING_SOON,
      changePercentage: LABEL_COMING_SOON,
    },
    bonusesLastMonth: {
      amount: LABEL_COMING_SOON,
      currencyCode: LABEL_COMING_SOON,
      changePercentage: LABEL_COMING_SOON,
    },
    incomeLastMonth: {
      amount: LABEL_COMING_SOON,
      currencyCode: LABEL_COMING_SOON,
      changePercentage: LABEL_COMING_SOON,
    },
  },
};
